import React from 'react';
import EstimationBlock from '../templates/common/estimationBlock';
import SliderControllerBlock from '../templates/common/sliderControllerBlock';
import replaceCommaWithDot from '../../../helpers/utils/replaceCommaWithDot';
import DOMPurify from 'utils/sanitize';

export default function template(context) {
    const calc = context.calc,
      model = calc.state.model,
      terms = model.getTerms(),
      creditsList = model.getListOfCredits(),
      termBtns = (
        <>
          {terms.map((item, index) => {
            return (
              <button 
                className={`controllers-calculator-new__btn controllers-calculator-new__btn_${index + 1} ${model.getTerm() === index ? 'active' : ''}`} 
                name="term" 
                key={item} 
                onClick={calc.handleChange} 
                value={index}
              >
                {item} {calc.l10n('CALCULATOR_DAYS')}
              </button>
            )
          })}
        </>
      ),
      selectOptions = (
        <>
          {creditsList.map((item, index) => {
            return (
              <button
                key={item}
                name={item}
                className={`controllers-calculator-new__btn controllers-calculator-new__btn_${index + 1} ${model.mode === item ? 'active' : ''}`}
                onClick={calc.toggleMode}
              >
                {calc.l10n(item.toUpperCase())}
              </button>
            );
          })}
        </>
      );


  const estimationData = [
    {
      label: calc.l10n('CALCULATOR_CREDLINE_TRANCHE_SUM'),
      value: `${replaceCommaWithDot(model.getCreditSum().toLocaleString('uk-UA'))} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDLINE_TRANCHE_TERM'),
      value: `${model.getTrancheTerm().toLocaleString()} ${calc.l10n('CALCULATOR_DAYS')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDLINE_TRANCHE_COST'),
      value: `${replaceCommaWithDot(model.getTrancheCost().toLocaleString('uk-UA'))} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDLINE_TRANCHE_COMMISSION'),
      value: `${replaceCommaWithDot(model.getOneTimeCommission().toLocaleString('uk-UA'))}${calc.l10n('PERCENT')} / ${replaceCommaWithDot(model.сalcOneTimeCommission().toLocaleString('uk-UA'))} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDLINE_TRANCHE_RATE'),
      value: `${replaceCommaWithDot(model.getTrancheRate().toLocaleString('uk-UA'))}${calc.l10n('PERCENT')} / ${replaceCommaWithDot(model.getTrancheCommission().toLocaleString('uk-UA'))} ${calc.l10n('UAH_ICON')}`,
    },
  ];
  
  return (
    <>
      <div className="calculator-new__top top-calculator-new">
        <div className="top-calculator-new__body">
          <h2 className="top-calculator-new__title">{calc.l10n('CALCULATOR_NEW_TITLE')}</h2>
          <div className="top-calculator-new__base-rate">
            {calc.l10n("CALCULATOR_NEW_CREDIT_LINE_BASE_RATE")}
          </div>
        </div>
      </div>
      <div className="calculator-new__bottom">
        <div className="calculator-new__controllers controllers-calculator-new">
          <div className="controllers-calculator-new__title">
            {calc.l10n('CALCULATOR_NEW_CREDIT_LINE_CONTROLLER_FORMAT_TITLE')}
          </div>
          <div className={`controllers-calculator-new__row controllers-calculator-new__row_${creditsList.length}`}>
            {selectOptions}
          </div>
        </div>
        <SliderControllerBlock
          title={calc.l10n('CALCULATOR_NEW_CREDIT_LINE_CONTROLLER_SUM_TITLE')}
          titleNote={`${calc.l10n('CALCULATOR_NEW_CREDIT_LINE_CONTROLLER_SUM_TITLE_NOTE_01')} ${model.getMaxSumEdge().toLocaleString('uk-UA')} ${calc.l10n('CALCULATOR_NEW_CREDIT_LINE_CONTROLLER_SUM_TITLE_NOTE_02')}`}
          inputName="creditSum"
          value={model.getCreditSum()}
          currency={calc.l10n('UAH_ICON')}
          min={model.getMinSumEdge()}
          max={model.getMaxSumEdge()}
          step={model.getSumStep()}
          currencyOffset={calc.state.valueWith}
          hiddenValueRef={calc.hiddenValue}
          onInputChange={calc.handleChangeInput}
          onInputBlur={calc.blurChangeInput}
          onRangeChange={calc.handleChange}
        />
        <div className="calculator-new__controllers controllers-calculator-new">
          <div className="controllers-calculator-new__title">
            {calc.l10n('CALCULATOR_NEW_CREDIT_LINE_CONTROLLER_TERM_TITLE')}
          </div>
          <div className={`controllers-calculator-new__row controllers-calculator-new__row_${terms.length}`}>
            {termBtns}
          </div>
        </div>
        <EstimationBlock
          title={calc.l10n('CALCULATOR_NEW_ESTIMATION_TITLE')}
          items={estimationData}
        />
        <button className="calculator-new__order-btn" onClick={calc.props.onBtnClick} id={`${calc.props.page ? calc.props.page : ''} calculator-new-button`}>
          {calc.l10n('EXPRESS_APPLICATION_APPLY_BTN')}
        </button>
        <div className='calculator-new__hint-info' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(calc.l10n('CALCULATOR_NEW_CREDIT_LINE_HINT_INFO')) }}></div>
      </div>
    </>
  );
}
